















































import _ from 'lodash';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { IImpressionSchedule } from '@/pages/campaign/adset/editingTypes';

@Component<ScheduleTableSelector>({
    name: 'ScheduleTableSelector',
})
export default class ScheduleTableSelector extends Vue{
    @Prop({type: Array, required: true}) value!: IImpressionSchedule[];
    @Prop({type: Boolean, default: true}) edit!: boolean;
    private data: IImpressionSchedule[] = [];
    private downElement: HTMLElement | null = null;
    private downPoint: number[] = [];
    private nowPoint: number[] = [];
    private startValue = false;
    private days = ['일', '월', '화', '수', '목', '금', '토'];
    
    @Watch('value', {deep: true})
    private vModelWatch(val: any, oldVal: any) {
        this.data = _.cloneDeep(val);
        this.data = _.cloneDeep(this.data);
    }
    get model() {
        return this.data;
    }
    set model(v: any) {
        this.data = v;
    }
    private selectStart(v: boolean, day: number, index: number, e: Event) {
        this.downPoint = [day, index];
        this.nowPoint = [day, index];
        this.startValue = !v;
        const el = e.target as HTMLElement;
        const mask = this.$refs.mask as HTMLElement;

        if (this.startValue) mask.setAttribute('data-mode', "1");
        else mask.setAttribute('data-mode', "0");

        mask.style.top = el.offsetTop + 'px';
        mask.style.left = el.offsetLeft + 'px';
        mask.style.width = el.offsetWidth + 'px';
        mask.style.height = el.offsetHeight + 'px';
        this.downElement = el;
    }
    private selectEnd() {
        const mask = this.$refs.mask as HTMLElement;

        const d = this.downPoint;
        const u = this.nowPoint;

        const startPoint = [
            d[0] > u[0] ? u[0] : d[0],
            d[1] > u[1] ? u[1] : d[1],
        ];
        const endPoint = [
            d[0] < u[0] ? u[0] : d[0],
            d[1] < u[1] ? u[1] : d[1],
        ];
        for (let i = startPoint[0]; i <= endPoint[0]; i++) {
            for(let j = startPoint[1]; j <= endPoint[1]; j++ ) {
                this.data[i].schedule[j] = this.startValue;
            }
        }
        this.downPoint = [];
        this.startValue = false;
        mask.setAttribute('data-mode', "-1");
        this.$emit('input', this.data);
    }
    private selectMove(v: boolean, day: number, index: number, e: Event) {
        const mask = this.$refs.mask as HTMLElement;
        if (this.downElement && this.downPoint && this.downPoint.length === 2) {
            if (this.nowPoint[0] == day && this.nowPoint[1] == index) {
                return;
            }
            this.nowPoint = [day, index];
            const el = e.target as HTMLElement;
            const d = this.downElement as HTMLElement;
            let top=0, left=0, width=0, height=0;
            
            if (el.offsetTop < d.offsetTop ) {
                top = el.offsetTop;
                height = d.offsetTop + d.offsetHeight - top;
            } else {
                top = d.offsetTop;
                height = el.offsetTop + el.offsetHeight - top;
            }

            if (el.offsetLeft < d.offsetLeft) {
                left = el.offsetLeft;
                width = d.offsetLeft + d.offsetWidth - left;
            } else {
                left = d.offsetLeft;
                width = el.offsetLeft + el.offsetWidth - left;
            }
            
            mask.style.top = top + 'px';
            mask.style.left = left + 'px';
            mask.style.width = width + 'px';
            mask.style.height = height + 'px';
        }
    }

    private created() {
        this.data = _.cloneDeep(this.value);
    }
}
